import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./Riderdatatable.css";
import Banner from "../Banner/Banner";
import Baseurl from "../BaseURL/Baseurl";

function Riderdatatable() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [, setError] = useState(null);
  const navigate = useNavigate();

  const { id } = useParams();
  const { state } = useLocation();
  console.log(state.item, "usamaid....");
  const itemdata = state;

  localStorage.setItem("RacereName", JSON.stringify(itemdata));
  const Usama = async () => {
    try {
      const response = await axios.get(
        `${Baseurl.baseurl}get-rider-data/${id}`
      );
      setData(response?.data);
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => {
    Usama();
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const fakeAsyncAction = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulating a 2-second delay
      setLoading(false);
    };

    fakeAsyncAction();
  }, []);
  const Loader = () => {
    return (
      <div className="loader-wrapper">
        <div className="loader">
          <img
            className="loaderimg"
            src="/assets/images/loader.gif"
            alt="loader"
          />
        </div>
      </div>
    );
  };
  return (
    <>
      {/* {loading && <Loader />} */}
      <Banner title="Driver" slug="RACING List" />

      <div className="container">
        <div className="row">
          <div className="col-md-3" style={{ width: "auto" }}>
            <h2 style={{ fontSize: "auto" }}>{state.item.Driver}</h2>
          </div>
          <div className="col-md-3">
            <img
              src={`https://${state.item.Rider_Country_Img}`} // Updated line
              alt="Country"
              style={{ scale: "1.5", marginTop: "15px" }}
              onLoad={() =>
                console.log(`Image loaded: ${state.item.Rider_Country_Img}`)
              }
              onError={() =>
                console.error(
                  `Error loading image: ${state.item.Rider_Country_Img}`
                )
              }
            />
          </div>
          <div className="col-md-6"></div>
        </div>
        <div className="row">
          <div className="col-md-3 d-flex">
            &nbsp;<h5 style={{ color: "rgb(238, 18, 67)" }}>Born:</h5>
            <h5 className="text-center" style={{ fontSize: "auto" }}>
              &nbsp;{state.item.Born}
            </h5>
          </div>
          <div className="col-md-9"></div>
        </div>
        <div className="row">
          <div className="col-md-3 d-flex">
            &nbsp;<h5 style={{ color: "rgb(238, 18, 67)" }}>Home:</h5>
            <h5 className="text-center" style={{ fontSize: "16px" }}>
              &nbsp;{state.item.Home}
            </h5>
          </div>
          <div className="col-md-9"></div>
        </div>
        <div className="row">
          <div className="col-md-3 d-flex">
            &nbsp;<h5 style={{ color: "rgb(238, 18, 67)" }}>Died: </h5>
            <h5 className="text-center" style={{ fontSize: "auto" }}>
              &nbsp;{state.item.Died}
            </h5>
          </div>
          <div className="col-md-9"></div>
        </div>
        <hr />
      </div>

      <div
        className="container"
        style={{
          border: "solid",
          padding: "10px",
          marginBottom: "10px",
          marginTop: "10px",
          borderRadius: "5px",
        }}
      >
        <span className="ridername">
          {data && data.length > 0 && data[0]?.rider_name}
        </span>
        <br />
        <br />

        {data?.map((e, index) => (
          <>
            <span className="tablnename">{e?.table_name}</span>
            <div className="tablees-container">
            {loading ? (
        <Loader />
      ) : (
              <table className="table  table-dark table-striped table-bordered border-light">
                <thead>
                  <tr
                    key={index}
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    {e?.csv_data[0] &&
                      Object.keys(e.csv_data[0])
                        .slice(0, -2) // Exclude the last two keys
                        .map((k) => (
                          <th
                            key={k}
                            scope="col"
                            style={{
                              width: "auto",
                              background: "#ee1243",
                              fontWeight: "bold",
                            }}
                          >
                            {k}
                          </th>
                        ))}
                  </tr>
                </thead>
                <tbody>
                  {e?.csv_data?.map((item, rowIndex) => (
                    <tr
                      key={rowIndex}
                      style={{
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {Object.entries(item)
                        .slice(0, -2)
                        .map(([key, value], index) => (
                          <td key={index}>
                            {console.log(value, "value")}
                            {key === "Races" || key === "Race" ? (
                              <span
                                onClick={() =>
                                  (item.Races || item.Race) &&
                                  navigate(
                                    item.Races || item.Race
                                      ? item.Races
                                        ? `/ridernametable/${item.races_uuid}`
                                        : `/riderrace/${item.race_uuid}`
                                      : ""
                                  )
                                }
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  cursor:
                                    item.Races || item.Race
                                      ? "pointer"
                                      : "default",
                                }}
                                className="colorhover"
                              >
                                {value}
                              </span>
                            ) : (
                              value
                            )}
                          </td>
                        ))}
                    </tr>
                  ))}
                </tbody>
              </table>
      )}
            </div>
          </>
        ))}
      </div>
    </>
  );
}

export default Riderdatatable;
